(() => {
  const modalSelector = '.jdgm-write-review-modal--compact';
  const watchedModals = new WeakSet();
  const reviewWidget = document.getElementById('judgeme_product_reviews');

  const clearReviewIntent = () => {
    const url = new URL(window.location.href);
    if (url.searchParams.get('write_review') !== '1') return;
    url.searchParams.delete('write_review');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  };

  if (reviewWidget) {
    let waitingToOpen = false;
    const findWriteButton = () => Array.from(reviewWidget.querySelectorAll('button'))
      .find((button) => /write a review/i.test(button.textContent || ''));

    const openWhenReady = () => {
      if (!waitingToOpen) return;
      const button = findWriteButton();
      if (!button || button.disabled) return;
      waitingToOpen = false;
      reviewWidgetObserver.disconnect();
      button.click();
    };

    const reviewWidgetObserver = new MutationObserver(openWhenReady);
    const openReviewForm = () => {
      waitingToOpen = true;
      reviewWidgetObserver.observe(reviewWidget, { childList: true, subtree: true, attributes: true });
      openWhenReady();
      if (waitingToOpen) reviewWidget.scrollIntoView({ block: 'start' });
    };

    document.querySelectorAll('[data-rumiloo-write-review]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        openReviewForm();
      });
    });

    if (new URLSearchParams(window.location.search).get('write_review') === '1') {
      openReviewForm();
    }
  }

  const watchModal = (modal) => {
    if (watchedModals.has(modal)) return;
    watchedModals.add(modal);

    let closing = false;
    const closeAfterSuccess = () => {
      const successPage = modal.querySelector('.jdgm-write-review-modal__page--thank-you.current-page');
      const isVisible = successPage &&
        getComputedStyle(modal).display !== 'none' &&
        getComputedStyle(successPage).visibility === 'visible';

      if (!isVisible) {
        closing = false;
        return;
      }
      if (closing) return;

      const closeButton = successPage.querySelector('.jdgm-write-review-modal__nav-btn-close');
      if (!closeButton) return;

      closing = true;
      clearReviewIntent();
      closeButton.click();
    };

    new MutationObserver(closeAfterSuccess).observe(modal, {
      attributes: true,
      attributeFilter: ['class', 'style', 'data-current-page'],
      childList: true,
      subtree: true
    });
    closeAfterSuccess();
  };

  document.querySelectorAll(modalSelector).forEach(watchModal);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches(modalSelector)) watchModal(node);
        node.querySelectorAll(modalSelector).forEach(watchModal);
      }
    }
  }).observe(document.body, { childList: true });
})();
